module.exports = __webpack_public_path__ + "static/media/AccountAddition.eac4c633.svg";